module.exports = require('./kmeans');


/*****************
 ** WEBPACK FOOTER
 ** ./~/ml-kmeans/src/index.js
 ** module id = 128
 ** module chunks = 0
 **/